<template>
	<Page animate>
		<template v-slot:content>
			<SafeAreaTop :showClose="false">
				<div class="container">
					<div class="title">Looking to increase your chance of success by 74%?</div>
					<div class="subtitle">
						Studies show that people feel more obligated to follow through with something once they’ve made a strong
						commitment.
					</div>
					<div class="subtitle">
						This principle also applies to weight loss. You can lose the weight. You just need to commit.
					</div>
					<div class="subtitle">
						<b>
							Simple members who commit today by skipping their trial period increase their chances of reaching their
							ideal weight by 74%!
						</b>
					</div>

					<div class="bar-chart">
						<div class="bar-chart-item bar-chart-trial">
							<span>Trial</span>
						</div>
						<div class="bar-chart-item bar-chart-skip">
							<span>Skip Trial & Commit Today</span>
							<b>+74%</b>
						</div>
					</div>

					<table v-if="product && product_upsale" class="table table-price mt-4">
						<thead>
							<tr>
								<td>Price breakdown</td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>12-week plan with trial</td>
								<td>{{ product.localizedPriceString }}</td>
							</tr>

							<tr class="text-primary">
								<td>Skip trial</td>
								<td>- {{ parseInt(product.price - product_upsale.price) }} {{ product.currencySymbol }}</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<td>Total today</td>
								<td>{{ product_upsale.localizedPriceString }}</td>
							</tr>
						</tfoot>
					</table>

					<div v-if="product_upsale" class="note-quote">
						When you click “Skip Trial and Start Plan”, your original trial payment method will be charged
						{{ product_upsale.localizedPriceString }}. Your payment method will then be automatically charged
						{{ product_upsale.localizedPriceString }} every 3 months (your “subscription period”) until you cancel. You
						can cancel anytime before the first day of your next subscription period to avoid automatic renewal. If you
						cancel before the end of a subscription period, you will not receive a partial refund.
					</div>
				</div>
			</SafeAreaTop>
		</template>

		<template v-slot:footer>
			<div class="container">
				<p-button @click.prevent="handleUpsale" :loading="isProcessUpsale" cls="btn-primary btn-block">
					Skip trial and start plan
				</p-button>

				<p-button @click.prevent="handleSkip" :loading="isProcessPayment" cls="btn btn-block btn-link"
					>Continue with trial</p-button
				>
			</div>
		</template>
	</Page>
</template>

<script>
import SafeAreaTop from '@/components/SafeAreaTop.vue'
import Page from '@/components/Page'
import PButton from '@/components/Button'
import { useStore } from 'vuex'
import { computed, ref } from '@vue/reactivity'
import useApi from '@/composition/api.js'
import { inject } from '@vue/runtime-core'
import useConfig from '@/composition/config.js'
import { useRouter } from 'vue-router'

export default {
	components: {
		SafeAreaTop,
		Page,
		PButton
	},

	setup() {
		const store = useStore()
		const api = useApi()
		const amplitude = inject('amplitude')
		const config = useConfig()
		const router = useRouter()

		const product = computed(() => store.getters['products/getProductById']('simple_full_price_subscription_3_months'))
		const product_upsale = computed(() =>
			store.getters['products/getProductById']('simple_original_subscription_3_months')
		)

		const next = computed(() => config.get({ key: 'postPaid.type', default_value: 'workbooks' }))

		const isProcessUpsale = ref(false)
		const isProcessPayment = ref(false)

		const close = (Status = 'Close') => {
			amplitude.logEvent('Paywall - Close', {
				Layout: 'Workbooks',
				From: store.getters['getSource'],
				Step: 'Upsale',
				Status
			})
			router.push({
				name: next.value
			})
		}

		const Purchase = (product) => {
			api.purchase({
				productId: product.id,
				onFinish: () => {
					amplitude.logEvent('Paywall - Done', {
						Layout: 'Workbooks',
						From: store.getters['getSource'],
						Step: 'Upsale',
						ProductId: product.id,
						Status: 'Subscribe'
					})
					close('Subscribe')
				},
				onError: () => {
					isProcessUpsale.value = false
					isProcessPayment.value = false
				},
				onCancel: () => {
					isProcessUpsale.value = false
					isProcessPayment.value = false
				},
				closeOnSuccess: false
			})
		}

		const handleUpsale = () => {
			isProcessUpsale.value = true
			Purchase(product_upsale.value)
		}

		const handleSkip = () => {
			isProcessPayment.value = true
			Purchase(product.value)
		}

		return {
			product,
			product_upsale,
			isProcessUpsale,
			isProcessPayment,
			handleUpsale,
			handleSkip
		}
	}
}
</script>

<style lang="scss" scoped>
.title {
	font-weight: 900;
	font-size: 1.4rem;
	text-align: center;
	max-width: 80%;
	margin-left: auto;
	margin-right: auto;
	padding-top: 2.5rem;
}

.subtitle {
	max-width: 90%;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	margin-top: 0.7rem;
}

.bar-chart {
	height: 10rem;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	padding-bottom: 2rem;
	margin-top: 2rem;

	&-item {
		width: 5.2rem;
		margin: 0 0.6rem;
		position: relative;

		span {
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.76rem;
			text-align: center;
			width: 100%;
			font-weight: bold;
			line-height: 1.3;
			margin-top: 0.5rem;
		}

		b {
			margin-top: 1.5rem;
			display: block;
			text-align: center;
			color: #fff;
		}
	}

	&-trial {
		height: 50%;
		background-color: #c4c4c4;
	}

	&-skip {
		height: 100%;
		background-color: #7d8bf7;
	}
}

.table {
	&-price {
		width: 100%;

		td {
			font-size: 1.1rem;

			&:last-child {
				text-align: right;
				white-space: nowrap;
			}
		}

		thead {
			td {
				border-bottom: 1px solid #e4e4e4;
				padding: 0.8rem 0;
				font-weight: bold;
				text-transform: uppercase;
			}
		}

		tbody {
			td {
				padding: 0.6rem 0;
			}
			tr {
				&:first-child {
					td {
						padding-top: 1.2rem;
					}
				}

				&:last-child {
					td {
						padding-bottom: 1.2rem;
					}
				}
			}
		}

		tfoot {
			td {
				border-top: 1px solid #e4e4e4;
				padding: 1rem 0;
				font-weight: bold;
			}
		}
	}
}

.note-quote {
	background-color: #f6f7f9;
	padding: 1.5rem;
	border-radius: 0.6rem;
	color: #666260;
	margin-top: 1.6rem;
}

.btn {
	text-transform: none;
}
.btn-link {
	margin-top: 0.5rem;
	margin-bottom: -1rem;
}
</style>
